import axiosInstance from '../axios/axiosInstance';
import type { SuperAdmin } from './superadmins';
export type { SuperAdmin } from './superadmins';

export interface LoginResponse {
  requires2FA?: boolean;
  requires2FASetup?: boolean;
  tempToken?: string;
  setupToken?: string;
}

export interface Setup2FAResponse {
  secret: string;
  qrCodeUrl: string;
}

export interface Enable2FAResponse {
  accessToken: string;
  backupCodes: string[];
}

export interface TokenResponse {
  accessToken: string;
}

export interface ValidateInviteResponse {
  email: string;
  valid: boolean;
}

export interface AcceptInviteResponse {
  setupToken: string;
}

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const { data } = await axiosInstance.post('/auth/login', { email, password });
    return data;
  },

  verify2FA: async (tempToken: string, code: string): Promise<TokenResponse> => {
    const { data } = await axiosInstance.post('/auth/verify-2fa', { tempToken, code });
    return data;
  },

  setup2FA: async (setupToken: string): Promise<Setup2FAResponse> => {
    const { data } = await axiosInstance.post('/auth/setup-2fa', { setupToken });
    return data;
  },

  enable2FA: async (
    setupToken: string,
    secret: string,
    code: string,
  ): Promise<Enable2FAResponse> => {
    const { data } = await axiosInstance.post('/auth/enable-2fa', {
      setupToken,
      secret,
      code,
    });
    return data;
  },

  logout: async (): Promise<void> => {
    await axiosInstance.post('/auth/logout');
  },

  getMe: async (): Promise<SuperAdmin> => {
    const { data } = await axiosInstance.get('/auth/me');
    return data;
  },

  forgotPassword: async (email: string): Promise<void> => {
    await axiosInstance.post('/auth/forgot-password', { email });
  },

  resetPassword: async (token: string, newPassword: string): Promise<void> => {
    await axiosInstance.post('/auth/reset-password', { token, newPassword });
  },

  validateInvite: async (token: string): Promise<ValidateInviteResponse> => {
    const { data } = await axiosInstance.post('/auth/validate-invite', { token });
    return data;
  },

  acceptInvite: async (
    token: string,
    name: string,
    password: string,
  ): Promise<AcceptInviteResponse> => {
    const { data } = await axiosInstance.post('/auth/accept-invite', {
      token,
      name,
      password,
    });
    return data;
  },

  regenerateBackupCodes: async (): Promise<{ backupCodes: string[] }> => {
    const { data } = await axiosInstance.post('/auth/regenerate-backup-codes');
    return data;
  },
};
